import { useContext, useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './SideBar.module.scss';
import MusicPlayer from '~/component/MusicPlayer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons';
import ThemeMode from '~/component/ThemeMode';
import LoginBTN from '~/component/LoginBTN';
import { NavLink } from 'react-router-dom';
import Button from '~/component/Button';
import routes from '~/configs';
import { LoginContext } from '~/component/Context/LoginProvider';
import { AnimatePresence, motion } from 'framer-motion';
import { ModalOverLayContext } from '~/component/Context/ModalOverLayProvider';

const cx = classNames.bind(styles);

function SideBar() {
  const [isOpen, setIsOpen] = useState(false);
  const { loginStatus } = useContext(LoginContext);
  const { setModalComponentContent } = useContext(ModalOverLayContext);

  const toggleSidebar = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    if (isOpen) setModalComponentContent(null);
  }, [isOpen]);

  return (
    <div className={cx('wrapper')}>
      <AnimatePresence>
        {isOpen ? (
          <>
            <motion.div
              className={cx('overlay')}
              onClick={() => setIsOpen(false)}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
            />
            <motion.div
              className={cx('sidebar')}
              initial={{ x: '-100%' }}
              animate={{ x: 0 }}
              exit={{ x: '-100%' }}
              transition={{ type: 'tween', duration: 0.3 }}
            >
              <ThemeMode />
              <MusicPlayer />
              {loginStatus ? (
                <div className={cx('tools')}>
                  <NavLink to={routes.createPost} className={cx('nav')}>
                    <Button>Đăng bài</Button>
                  </NavLink>
                  <NavLink to={routes.notePage} className={cx('nav')}>
                    <Button>Note</Button>
                  </NavLink>
                  <NavLink to={routes.editCv} className={cx('nav')}>
                    <Button>Sửa CV</Button>
                  </NavLink>
                  <NavLink to={routes.admin} className={cx('nav')}>
                    <Button>Chat</Button>
                  </NavLink>
                </div>
              ) : null}
              <div className={cx('bottom')}>
                <LoginBTN setOpenSidebar={setIsOpen} />
              </div>
              <div className={cx('icon-w2', { hide: !isOpen })} onClick={toggleSidebar}>
                <FontAwesomeIcon className={cx('icon')} icon={faCaretRight} />
              </div>
            </motion.div>
          </>
        ) : null}
      </AnimatePresence>
      <div className={cx('icon-w', { show: !isOpen })} onClick={toggleSidebar}>
        <FontAwesomeIcon className={cx('icon')} icon={faCaretRight} />
      </div>
    </div>
  );

  return (
    <div className={cx('wrapper')}>
      {isOpen && <div className={cx('overlay')} onClick={() => setIsOpen(false)}></div>}
      <div className={cx('sidebar', { open: isOpen })}>
        <ThemeMode />
        <MusicPlayer />
        {loginStatus && (
          <div className={cx('tools')}>
            <NavLink to={routes.createPost} className={cx('nav')}>
              <Button>Đăng bài</Button>
            </NavLink>
            <NavLink to={routes.notePage} className={cx('nav')}>
              <Button>Note</Button>
            </NavLink>
            <NavLink to={routes.editCv} className={cx('nav')}>
              <Button>Sửa CV</Button>
            </NavLink>
            <NavLink to={routes.editCv} className={cx('nav')}>
              <Button>Sửa CV</Button>
            </NavLink>
          </div>
        )}
        <div className={cx('bottom')}>
          <LoginBTN setOpenSidebar={setIsOpen} />
        </div>
      </div>
      <div className={cx('icon-w', { active: isOpen })} onClick={toggleSidebar}>
        <FontAwesomeIcon className={cx('icon')} icon={faCaretRight} />
      </div>
    </div>
  );
}

export default SideBar;
